module.exports = __webpack_public_path__ + "/119bd24ff4a608ef7d5901728f475934.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_googledocs.png
 ** module id = 1659
 ** module chunks = 0
 **/